import { createAsyncThunk } from "@reduxjs/toolkit";
import { helpers } from "../../../../packages/helpers";
import { ActionStoreParams } from "../../../../store";
import { getAccessAuthorizationHeaders } from "../../../../api";
import { getChatSettingsData } from "../../providers";
import { CHAT_ACTIONS } from "../../types";
import type { GetChatSettingsApiCallback } from "../../types";

const { getActionErrorText } = helpers.error;

type ActionReturn = ReturnType<typeof getChatSettingsData>;

type ActionParams = {
  userId: string;
  chatId: string;
  getChatSettingsApi: GetChatSettingsApiCallback;
};

export const getChatSettings = createAsyncThunk<
  ActionReturn,
  ActionParams,
  ActionStoreParams
>(
  CHAT_ACTIONS.GET_CHAT_SETTINGS,
  async ({ userId, chatId, getChatSettingsApi }, { getState }) => {
    try {
      const headers = getAccessAuthorizationHeaders(getState());
      const resp = await getChatSettingsApi(userId, { chatId }, { headers });

      return getChatSettingsData(resp);
    } catch (e) {
      throw new Error(getActionErrorText(e));
    }
  }
);
